var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CustomIonInfiniteScroll,{ref:"infiniteScroll",attrs:{"disabled":_vm.disabled,"spinner":!_vm.hideSpinner && _vm.loading,"threshold":_setup.thresholdValue,"scrollElement":_vm.scrollContainer},on:{"ionInfinite":function($event){return _vm.$emit('load-next', { event: $event })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }